import { all } from 'redux-saga/effects';
import { watchCoachSagas } from './coach/coachSaga';
import { watchClientSagas } from './client/clientSaga';
import { watchNoteSagas } from './note/noteSaga';
import { watchActivitySagas } from './activity/activitySaga';
import { watchAppointmentSagas } from './appointment/appointmentSaga';
import { watchForgetPasswordSagas } from './forgetPassword/forgetPasswordSaga';
import { watchOnboardingSagas } from './onboarding/onboardingSaga';
import { watchActivityLibrarySagas } from './activityLibrary/activityLibrarySaga';
import { watchNotificationSagas } from './notification/notificationSaga';
import { watchChatSagas } from './chat/chatSaga';
import { watchUserGroupsSagas } from './userGroups/userGroupsSaga';
import { watchSubscriptionSagas } from './subscription/subscriptionSaga';
import { watchBookingSagas } from './booking/bookingSaga';
import { watchMiniwebSagas } from './miniweb/miniwebSaga';
import { watchCoachGroupSagas } from './coachGroup/coachGroupSaga';

function* rootSaga() {
  yield all([
    watchCoachSagas(),
    watchClientSagas(),
    watchNoteSagas(),
    watchAppointmentSagas(),
    watchActivitySagas(),
    watchForgetPasswordSagas(),
    watchOnboardingSagas(),
    watchActivityLibrarySagas(),
    watchNotificationSagas(),
    watchChatSagas(),
    watchUserGroupsSagas(),
    watchSubscriptionSagas(),
    watchBookingSagas(),
    watchMiniwebSagas(),
    watchCoachGroupSagas(),
  ]);
}

export default rootSaga;
